import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { registerField } from 'core/forms';

import { Markdown } from 'uikit/content';

import styles from '../styles/formFieldBulletList.module.scss';

const transformList = (value) => value.map((content) => `- ${content}`).join('\n');

const FormFieldBulletList = ({ fieldId, schema, value = [] }) => {
  if (!value) return null;

  const { emptyStateText } = schema;

  return (
    <div className={styles.element} id={fieldId}>
      {!value.length && !!emptyStateText ? (
        <Markdown className={styles.emptyState} content={emptyStateText} />
      ) : (
        <Markdown className={styles.list} content={transformList(value)} />
      )}
    </div>
  );
};

FormFieldBulletList.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    emptyStateText: PropTypes.string,
  }).isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
};

registerField('BulletList', memo(FormFieldBulletList));

export default FormFieldBulletList;
